"use client";

import { SupportIcon } from "@shared/src/components/assets/icons";
import { Button } from "@shared/src/components/ui/button";
import { useModalStore } from "@shared/src/stores/useModalStore";
import FeedbackForm from "@shared/src/components/common/misc/FeedbackDialogue";

export function SupportFeedback() {
  const showModal = useModalStore(state => state.showModal);

  const handleClick = () => {
    showModal({
      type: "custom",
      title: "Feedback",
      message: <FeedbackForm />,
      description: "Thank you for taking the time to help us improve our service!",
    });
  };

  return (
    <Button
      onClick={handleClick}
      variant="primary"
      size="cta"
      radius="full"
      className="fixed size-9 bottom-24 md:bottom-8 left-4 md:right-8 z-50"
    >
      <SupportIcon className="text-text-primary" size={32} />
    </Button>
  );
}
